import React from 'react'

import { ReactSDKClient } from '@optimizely/react-sdk'

import { APP_ID } from 'app-constants'
import trackEvent from 'utils/analytics/trackEvent'
import { ReactErrorBoundaryError, sendToSentry } from 'utils/errors'
import { withOptimizely } from 'utils/Optimizely'

import { ErrorState } from './ErrorState'

type Props = {
  optimizely: ReactSDKClient
  children: React.ReactNode
}

class ErrorBoundaryClass extends React.Component<Props, { hasError: boolean }> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: any) {
    const userId = this.context.userId

    trackEvent('Page Crash', {
      eventData: {
        app: APP_ID,
        error: error.toString(),
        enabled_feature_toggles: this.props.optimizely.getEnabledFeatures(userId),
        error_boundary_url_location: window.location.href,
        ...info,
      },
    })

    sendToSentry(new ReactErrorBoundaryError(error, window.location.href), {
      extras: {
        userId,
        enabled_feature_toggles: this.props.optimizely.getEnabledFeatures(userId),
        info,
        localStorage: { ...localStorage },
        sessionStorage: { ...sessionStorage },
      },
    })

    this.setState({ hasError: true })
  }

  render() {
    if (this.state.hasError) {
      return <ErrorState />
    }

    return this.props.children
  }
}

export const ErrorBoundary = withOptimizely(ErrorBoundaryClass)
